import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { TitleOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceTitleEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);

  const handleChange = (value: string) => {
    updateRequest({ title: value });
  };

  return (
    <TextField
      label="Maintenance Title"
      value={request?.title || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      required
      placeholder="Enter maintenance request title"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TitleOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FacilityMaintenanceTitleEditor;
